var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsNumber, IsObject, IsOptional, IsUUID, } from "class-validator";
export class CreatePollQuestionOptionDto {
    title;
    order;
}
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], CreatePollQuestionOptionDto.prototype, "title", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreatePollQuestionOptionDto.prototype, "order", void 0);
export class MutatePollQuestionDto {
    title;
    order;
    options;
}
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], MutatePollQuestionDto.prototype, "title", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], MutatePollQuestionDto.prototype, "order", void 0);
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], MutatePollQuestionDto.prototype, "options", void 0);
export class CreatePollDto {
    title;
    description;
    questions;
}
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], CreatePollDto.prototype, "title", void 0);
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], CreatePollDto.prototype, "description", void 0);
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], CreatePollDto.prototype, "questions", void 0);
export class MutatePollDto {
    title;
    description;
    questions;
}
__decorate([
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], MutatePollDto.prototype, "title", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], MutatePollDto.prototype, "description", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], MutatePollDto.prototype, "questions", void 0);
export class SendPollDto {
    contact_id;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], SendPollDto.prototype, "contact_id", void 0);
